<template>
    <div>
        <Title title="人员流动趋势">
            <Echarts 
                :options="polar"
                style="width: 100%;height: 100%"
                autoresize
                v-if="ifShowEcharts"/>
        </Title>
    </div>    
</template>
<script>
import miment from 'miment';
import Echarts from "vue-echarts";
// 引入柱状图
require("echarts/lib/chart/bar");
// 引入提示框和标题组件
require("echarts/lib/component/tooltip");
require("echarts/lib/component/title");
require("echarts/lib/component/grid");
require("echarts/lib/component/legendScroll");
require("echarts/lib/component/dataZoom");
import Title from './title'
export default {
    components: { Title,Echarts },
    data(){
        return {
            ifShowEcharts: false,
            polar:  {
                tooltip: {
                    trigger: "axis"
                },
                grid: {
                    left: "0",
                    right: "0",
                    bottom: "15",
                    top: "35",
                    containLabel: true
                },
                legend: {
                    data: [
                        "每日返回人数"
                    ],
                    top: "15",
                    right: 0,
                    textStyle: {
                        color: '#949a98'
                    }
                },
                xAxis: {
                    type: "category",
                    data: [],
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        color: "#959a9e"
                    },
                    axisLabel: {
                        color: "#959a9e",
                        interval: 0,
                        rotate: 30
                    },
                    splitLine: {
                        show: false
                    }
                },
                yAxis: {
                    type: "value",
                    axisTick: {
                        show: false
                    },
                    axisLine: {
                        color: "#959a9e"
                    },
                    axisLabel: {
                        color: "#959a9e"
                    },
                    splitLine: {
                        show: false
                    }
                },
                dataZoom: [
                    {
                        type: "inside",
                        startValue: 0,
                        endValue: 10
                    }
                ],
                series: [
                    {
                        name: "每日返回人数",
                        type: "line",
                        prop: "backUserCount",
                        smooth: true,
                        barWidth: 22,
                        data: [],
                        areaStyle: {
                            color: {
                                type: "linear",
                                x: 0,
                                y: 0,
                                x2: 0,
                                y2: 1,
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: "rgba(243,115,114,1)" // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: "rgba(243,115,114,0)" // 100% 处的颜色
                                    }
                                ],
                                global: false
                            }
                        }
                    }
                ]
            }
        }
    },
    props: {
        date: {
            type: String
        }
    },
    methods: {
        // 获取信息
        async getInfo(starttime,endtime){
            let res = await this.$get(this.urlobj.getEpidemicTrendsStatistics,{
                communityId:this.$route.query.communityId || this.$store.state.streetorcommunityid,
                type: 1,
                beginTime: starttime,
                endTime: endtime
            })
            this.polar.xAxis.data = res.rows.map(item => {
                return  `${ item.daytime.split('-')[1] }-${ item.daytime.split('-')[2] }`
            })
            this.polar.dataZoom[0].endValue = res.rows.length - 1;
            this.polar.dataZoom[0].startValue = res.rows.length - 15;
            this.polar.series[0].data = res.rows.map(item => item.backUserCount);
        
            this.ifShowEcharts = true;
        }
    },
    watch: {
        date(newVal){
            let starttime,endtime

            

            if(newVal == '日期选择'){
                this.getInfo();
                return
            }

            if(newVal.length == 6){
                let year = newVal.substring(0,4);
                let month = newVal.substring(4);
                starttime = miment(year + '-' + month + '-' + '01').format('YYYY-MM-DD');
                endtime = miment(year + '-' + month + '-' + new Date(year,month,0).getDate()).format('YYYY-MM-DD');
            
                this.ifShowEcharts = false;
                this.getInfo(starttime,endtime)
            }else if(newVal.length == 8){
                let year = newVal.substring(0,4);
                let month = newVal.substring(4,6);
                let date = newVal.substring(6,7);
                starttime = miment(year + '-' + month + '-' + date).format('YYYY-MM-DD');
                endtime = miment(year + '-' + month + '-' + date).format('YYYY-MM-DD');
            
                this.ifShowEcharts = false;
                this.getInfo(starttime,endtime)
            }
        }
    },
    created(){
        this.getInfo();
    }
}
</script>
<style lang="less" scoped>

</style>